const LoggedInLayout = () => import("../../views/LoggedInLayout.vue");

const DashBoard = r => require.ensure([], () => r(require('./views/DashboardTest.vue')))

const moduleRoute = {
  path: "/",
  component: LoggedInLayout,
  children: [
    
    {
      path: "/dashboardnew",
      component: DashBoard
    }
  ]
};

export default router => {
  router.addRoutes([moduleRoute]);
};
